export const WALK_IN_ITEM_TYPES = {
  SERVICE: "service",
  PRODUCT: "product",
};

export function formatWalkInPrice(value) {
  if (value == null || value === "") return "";
  const n = Number(value);
  if (!Number.isFinite(n)) return "";
  return n.toFixed(2);
}

export function stylistServicePriceMap(stylistServices) {
  const map = {};
  for (const service of stylistServices || []) {
    if (service?.service_id == null) continue;
    map[String(service.service_id)] = service.servicePrice;
  }
  return map;
}

export function resolveWalkInItemPrice(option, priceByServiceId) {
  if (!option) return "";
  if (option.type === WALK_IN_ITEM_TYPES.PRODUCT) {
    return formatWalkInPrice(option.msrp);
  }
  if (option.type !== WALK_IN_ITEM_TYPES.SERVICE) return "";
  const key = String(option.referenceId ?? "");
  if (!key || !priceByServiceId || !Object.prototype.hasOwnProperty.call(priceByServiceId, key)) {
    return "";
  }
  return formatWalkInPrice(priceByServiceId[key]);
}

export function applyStylistPricesToItems(items, priceByServiceId) {
  return (items || []).map((item) => {
    if (item?.type !== WALK_IN_ITEM_TYPES.SERVICE) return item;
    const key = String(item.referenceId ?? item.selectedOption?.referenceId ?? "");
    const hasConfiguredPrice =
      Boolean(key) &&
      priceByServiceId &&
      Object.prototype.hasOwnProperty.call(priceByServiceId, key);
    const nextPrice = hasConfiguredPrice
      ? formatWalkInPrice(priceByServiceId[key])
      : "";
    const nextMsrp = hasConfiguredPrice ? Number(priceByServiceId[key]) : null;
    return {
      ...item,
      price: nextPrice,
      selectedOption: item.selectedOption
        ? {
            ...item.selectedOption,
            msrp: Number.isFinite(nextMsrp) ? nextMsrp : null,
          }
        : item.selectedOption,
    };
  });
}
